import { useNavigate } from "react-router-dom";
import { Settings, User, ShieldCheck, PhoneCall, Bell, Globe, LogOut, ChevronRight } from "lucide-react";
import { Card } from "@/components/ui/card";
import PageHeader from "@/components/PageHeader";
import { useAuthStore } from "@/store/authStore";
import { useLanguageStore } from "@/store/languageStore";

export default function AccountSettings() {
  const navigate = useNavigate();
  const logout = useAuthStore((s) => s.logout);
  const language = useLanguageStore((s) => s.language);
  const setLanguage = useLanguageStore((s) => s.setLanguage);

  const ITEMS = [
    { id: "profile", label: "Profile & Personal Info", icon: User, color: "#2563EB", to: "/profile" },
    { id: "privacy", label: "Privacy & Consent (DPDP)", icon: ShieldCheck, color: "#059669", to: "/consent" },
    { id: "emergency", label: "Emergency Contacts", icon: PhoneCall, color: "#DC2626", to: "/emergency-contacts" },
    { id: "notifications", label: "Notifications", icon: Bell, color: "#F59E0B", to: "/notifications" },
  ];

  const handleLogout = () => { logout(); navigate("/", { replace: true }); };

  return (
    <div className="max-w-3xl" data-testid="account-settings-page">
      <PageHeader title="Account Settings" subtitle="Manage your account & preferences" icon={Settings} color="#64748B" />

      <Card className="rounded-2xl divide-y divide-border overflow-hidden border-border">
        {ITEMS.map((it) => {
          const IIcon = it.icon;
          return (
            <button key={it.id} onClick={() => navigate(it.to)} className="w-full flex items-center gap-3 p-4 hover:bg-accent transition-colors text-left" data-testid={`settings-${it.id}`}>
              <div className="h-10 w-10 rounded-xl flex items-center justify-center shrink-0" style={{ backgroundColor: it.color + "1A" }}><IIcon className="h-5 w-5" style={{ color: it.color }} /></div>
              <span className="flex-1 text-sm font-medium">{it.label}</span>
              <ChevronRight className="h-4 w-4 text-muted-foreground" />
            </button>
          );
        })}
      </Card>

      {/* Language */}
      <Card className="rounded-2xl p-4 border-border mt-4">
        <p className="flex items-center gap-2 text-sm font-medium mb-3"><Globe className="h-4 w-4 text-[#7C3AED]" /> Language</p>
        <div className="flex gap-1 rounded-xl border border-border p-1">
          {[{ code: "en", label: "🇬🇧  English" }, { code: "hi", label: "🇮🇳  हिंदी" }].map((l) => (
            <button key={l.code} onClick={() => setLanguage(l.code)} data-testid={`settings-lang-${l.code}`} className={`flex-1 py-2 rounded-lg text-sm font-semibold transition-colors ${language === l.code ? "bg-[#059669] text-white" : "text-muted-foreground"}`}>{l.label}</button>
          ))}
        </div>
      </Card>

      <button onClick={handleLogout} className="w-full flex items-center justify-center gap-2 h-12 rounded-2xl border border-destructive/30 text-destructive font-medium mt-6" data-testid="settings-logout">
        <LogOut className="h-4 w-4" /> Log out
      </button>
    </div>
  );
}
